@defer (when system){
    <div class="flex gap-3">
        <img class="object-scale-down cursor-pointer" width="250px" [src]="system?.img?.url" [alt]="system?.name" [routerLink]="'/system/' + system?.systemRef">
        <div>
            <app-social-links [eventSystem]="system" />
            <p class="text-sm" [innerHTML]="system?.description"></p>
        </div>
    </div>
    <p-divider type="solid" styleClass="border-2" />  
}